import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=4c346887&scoped=true&"
import script from "./SearchInput.vue?vue&type=script&lang=ts&"
export * from "./SearchInput.vue?vue&type=script&lang=ts&"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=4c346887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c346887",
  null
  
)

export default component.exports